import React, { useEffect, useState, Fragment } from 'react';
import { Document, Page, PDFViewer, View, Text, Image, Font, pdf } from '@react-pdf/renderer';

import { pageStyle, textStyle, headerStyle, styleHeaderLogo, styleOMR } from './styleAnsweSheetPDF';
import { toast } from 'react-toastify';


Font.register({
    family: 'Calibri'
    , fonts: [{ src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf" }
        , { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold" }], format: 'truetype'
});

const AnswerSheedPDFAndroid = (props) => {
    const { logoUrl, noOfResponses, rowsPerColumn, noOfColumns, setFlgAnswerSheetAndroid } = props;
    const [loading, setLoading] = useState(true);
    const [documentOpeningCalled, setDocumentLoadingCalled] = useState(false);


    useEffect(() => {
        // console.log("useEffect in AnswerSheedPDF called, noOfResponses", noOfResponses, ", rowsPerColumn", rowsPerColumn, ", noOfColumns", noOfColumns);
        if (!documentOpeningCalled && noOfColumns && rowsPerColumn && rowsPerColumn) {
            openDocument();
        }
    }, [noOfResponses, rowsPerColumn, noOfColumns]);


    const getRow = (pQuesNo) => {
        return (
            <View key={pQuesNo} style={styleOMR.row}>
                <Text style={styleOMR.questionNumber}>{pQuesNo}</Text>
                <View style={styleOMR.circleContainer}>
                    {['A', 'B', 'C', 'D'].map((option) => (
                        <View key={option} style={[styleOMR.circle]}>
                            <Text style={styleOMR.circleText}>{option}</Text>
                        </View>
                    ))}
                </View>
            </View>
        );
    }

    const getColumn = (i) => {
        let quesNo = i * rowsPerColumn;
        const rows = [];
        for (let j = 0; j < rowsPerColumn; j++) {
            if (j + quesNo === noOfResponses) {
                break;
            }
            const row = getRow(j + quesNo + 1);
            rows.push(row);
        }
        return rows;
    }

    const columns = [];
    for (let i = 0; i < noOfColumns; i++) {
        const height = Math.min(rowsPerColumn, noOfResponses - i * rowsPerColumn) * 21 + "px";
        const column = getColumn(i);
        columns.push(
            <View key={i} style={[styleOMR.column, { height: height }]}>
                {column}
            </View>
        );
    }


    const openDocument = async () => {
        await setDocumentLoadingCalled(true);
        const document = await generateDocument();

        try {
            // Step 1: Generate the PDF Blob
            const blob = await pdf(document).toBlob();

            // Step 2: Check the file size (in bytes)
            const fileSizeInMB = blob.size / (1024 * 1024); // Size in MB

            // Define a threshold for the file size (for example, 10MB)
            const fileSizeThreshold = 10;

            if (fileSizeInMB > fileSizeThreshold) {
                // If file is too large, suggest downloading
                window.alert(`The file size is too large (${fileSizeInMB.toFixed(2)} MB). It may be slow to open. Downloading instead...`);

                // Force download if file is too large
                const downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = 'AnswerSheet.pdf';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else {
                // Step 3: Attempt to open the PDF in a new tab
                const fileURL = URL.createObjectURL(blob);
                const newTab = window.open(fileURL, '_blank');

                // Step 4: Check if the tab was successfully opened
                if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                    window.alert('Popup blocked. Downloading file instead...');
                    const downloadLink = document.createElement('a');
                    downloadLink.href = fileURL;
                    downloadLink.download = 'AnswerSheet.pdf'; // Set default filename
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            }
        } catch (error) {
            console.error('Error opening or downloading PDF:', error);
        }

        setLoading(false);
        setFlgAnswerSheetAndroid(false);
    };


    const generateDocument = () => new Promise((resolve) => {
        const generatedDocument = (
            <Document >
                <Page size="A4" style={pageStyle.page} wrap>
                    <View style={pageStyle.fullPage}>
                        <View style={pageStyle.pageHeader} >
                            <View style={headerStyle.row}>
                                <View style={headerStyle.leftSection}>
                                    <View style={headerStyle.column}>
                                        <View style={headerStyle.row}>
                                            <View style={headerStyle.viewLeftLabel}>
                                                <Text style={textStyle.textLeftMedium}>
                                                    {"Name: "}
                                                </Text>
                                            </View>
                                            <View style={headerStyle.vieLeftValue}>
                                                <Text style={textStyle.textLine}>
                                                    {"_________________________"}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={headerStyle.row}>
                                            <View style={headerStyle.viewLeftLabel}>
                                                <Text style={textStyle.textLeftMedium}>
                                                    {"Class: "}
                                                </Text>
                                            </View>
                                            <View style={headerStyle.vieLeftValue}>
                                                <Text style={textStyle.textLine}>
                                                    {"_________________________"}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={headerStyle.row}>
                                            <View style={headerStyle.viewLeftLabel}>
                                                <Text style={textStyle.textLeftMedium}>
                                                    {"Test: "}
                                                </Text>
                                            </View>
                                            <View style={headerStyle.vieLeftValue}>
                                                <Text style={textStyle.textLine}>
                                                    {"_________________________"}
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View style={headerStyle.midSection}>
                                    <View style={headerStyle.viewCenter}>
                                        <Image style={styleHeaderLogo.image1} src={logoUrl} />
                                    </View>
                                </View>
                                <View style={headerStyle.rightSection}>
                                    <View style={headerStyle.column}>
                                        <View style={headerStyle.row}>
                                            <View style={headerStyle.viewRightLabel1}>
                                                <Text style={textStyle.textLeftMedium}>
                                                    {"Date:"}
                                                </Text>
                                            </View>
                                            <View style={headerStyle.viewRightValue1}>
                                                <Text style={textStyle.textLine}>
                                                    {"__________________"}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={headerStyle.row}>
                                            <View style={headerStyle.viewRightLabel1}>
                                                <Text style={textStyle.textLeftMedium}>
                                                    {"Max Score:"}
                                                </Text>
                                            </View>
                                            <View style={headerStyle.viewRightValue1}>
                                                <Text style={textStyle.textLine}>
                                                    {"_________________"}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={headerStyle.row}>
                                            <View style={headerStyle.viewRightLabel}>
                                                <Text style={textStyle.textLeftMedium}>
                                                    {"Score Obtained:"}
                                                </Text>
                                            </View>
                                            <View style={headerStyle.viewRightValue}>
                                                <Text style={textStyle.textLine}>
                                                    {"____________"}
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                            <View style={pageStyle.horizontalBar2} fixed></View>
                            <View style={pageStyle.pageContent}>
                                {columns}
                            </View>
                        </View>
                    </View>
                </Page>
            </Document>
        );
        resolve(generatedDocument);
    });


    return (
        <div>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '70%', top: '45%', display: loading }} >
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div >
        </div>
    );
}

export default AnswerSheedPDFAndroid;

